import { injectIntl } from 'react-intl';

import IncidentsFilter from './IncidentsFilter';

export default injectIntl(IncidentsFilter);
